import React from 'react';
import { env } from '../../config/env';

const ImageComp: React.FunctionComponent<{
  imageId?: string | undefined;
  className?: string;
  divClass?: string;
  noImageClass?: string;
  noImageDivClass?: string;
  alt?: string;
  src?: string;
  loadingColor?: string;
  onImageClick?: (id: string) => void;
}> = ({
  className,
  alt,
  src,
  imageId,
  divClass,
  noImageClass,
  noImageDivClass,
  loadingColor,
  onImageClick,
}) => {
  return !imageId ? (
    <div className={noImageDivClass}>
      <img className={noImageClass} src={process.env.PUBLIC_URL + src} alt="" />
    </div>
  ) : (
    <div
      className={divClass}
      onClick={() => onImageClick && onImageClick(imageId)}
    >
      <img
        className={className}
        src={`${env.development.BASE_URL}/files/${imageId}`}
        alt=""
        crossOrigin=""
      />
    </div>
  );
};

export default ImageComp;
